import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import Markdown from '@/shared/components/Markdown';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';

// @ts-nocheck
export default function GeneralTab({ project, subsidiary, department }) {
    const analysisData = [
        { name: 'Année 1', Réaliste: 4000, Optimiste: 6400, VAN: 2400 },
        { name: 'Année 2', Réaliste: 3000, Optimiste: 4398, VAN: 3398 },
        { name: 'Année 3', Réaliste: 2000, Optimiste: 7800, VAN: 5800 },
        { name: 'Année 4', Réaliste: 2780, Optimiste: 5908, VAN: 4908 },
        { name: 'Année 5', Réaliste: 1890, Optimiste: 6800, VAN: 4800 },
    ];

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Left Column */}
            <div className="lg:col-span-2 space-y-6">
                <Card className="shadow-lg border-0">
                    <CardHeader>
                        <CardTitle>Informations du projet</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-2 gap-6 text-sm">
                            <div>
                                <p className="text-gray-500 mb-1">Catégorie</p>
                                <p className="font-medium capitalize">{project.type?.replace(/_/g, ' ')}</p>
                            </div>
                            <div>
                                <p className="text-gray-500 mb-1">Département</p>
                                <p className="font-medium">{department?.name || "Non défini"}</p>
                            </div>
                            <div>
                                <p className="text-gray-500 mb-1">Site</p>
                                <p className="font-medium">{subsidiary?.name || "Non défini"}</p>
                            </div>
                            <div>
                                <p className="text-gray-500 mb-1">Budget total</p>
                                <p className="font-medium">{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(project.total_budget || 0)}</p>
                            </div>
                            <div>
                                <p className="text-gray-500 mb-1">Date de début</p>
                                <p className="font-medium">{project.start_date ? new Date(project.start_date).toLocaleDateString('fr-FR') : "Non définie"}</p>
                            </div>
                            <div>
                                <p className="text-gray-500 mb-1">Date de fin prévue</p>
                                <p className="font-medium">{project.end_date ? new Date(project.end_date).toLocaleDateString('fr-FR') : "Non définie"}</p>
                            </div>
                        </div>
                        <div className="mt-6 prose prose-sm max-w-none">
                            <h4 className="font-semibold text-gray-800">Description du projet</h4>
                            <Markdown>{project.description || "Aucune description fournie."}</Markdown>
                            <h4 className="font-semibold text-gray-800 mt-4">Justification commerciale</h4>
                            <Markdown>{project.business_justification || "Non renseignée."}</Markdown>
                        </div>
                    </CardContent>
                </Card>
            </div>

            {/* Right Column */}
            <div className="space-y-6">
                <Card className="shadow-lg border-0">
                    <CardHeader>
                        <CardTitle>Analyse financière</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-2 gap-4 text-center mb-6">
                            <div>
                                <p className="text-xs text-gray-500">VAN</p>
                                <p className="text-lg font-bold text-green-600">1,45 M€</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">TRI</p>
                                <p className="text-lg font-bold text-green-600">18,7 %</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">Délai de récupération</p>
                                <p className="text-lg font-bold">2,8 ans</p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">ROI</p>
                                <p className="text-lg font-bold">35,6 %</p>
                            </div>
                        </div>
                        <div className="h-48">
                            <ResponsiveContainer width="100%" height="100%">
                                <AreaChart data={analysisData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                                    <defs>
                                        <linearGradient id="colorOptimiste" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#48C9B0" stopOpacity={0.8}/>
                                            <stop offset="95%" stopColor="#48C9B0" stopOpacity={0}/>
                                        </linearGradient>
                                        <linearGradient id="colorRealiste" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#2C5F5D" stopOpacity={0.8}/>
                                            <stop offset="95%" stopColor="#2C5F5D" stopOpacity={0}/>
                                        </linearGradient>
                                    </defs>
                                    <Tooltip />
                                    <Area type="monotone" dataKey="Optimiste" stroke="#48C9B0" fillOpacity={1} fill="url(#colorOptimiste)" />
                                    <Area type="monotone" dataKey="Réaliste" stroke="#2C5F5D" fillOpacity={1} fill="url(#colorRealiste)" />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
